<style lang="stylus" scoped>

    .menu-divide {
    	margin: 4px 0;

    	>hr {
            margin-left: 8px
            // width: 166px
    		height: 1px;
    		border: 0 none;
    	}
    }


    .expand-menu-item {
    	position: relative;
    	.expanded-menu {
    		background-color: white;
    		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    		position: absolute;
    		top: -2px;
    	}

    	.menu-text {
    		pointer-events: none;
            .text-icon {
                width: 16px !important
                height: 16px
            }
    	}

        .menu-tag {
            margin-left: auto;
        }
        .menu-item-icon {
            margin-left: 8px;
            svg {
                width 8px;
                height 8px;
                color: var(--svg-color-menu-expand-arrow)
            }
        }

    	// &:after {
    	// 	// content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAGFBMVEUAAAB1dXV0dHR0dHR1dXV0dHR2dnZ1dXXxfp/EAAAAB3RSTlMA779fMIBw/GLP2QAAABpJREFUCNdjgAAVEFFoACTKy0BEKYyrAlUAAERNA2S3+incAAAAAElFTkSuQmCC');
        //     content: url('~@/app/assets/topPanel/expend-arrow.svg')
    	// 	display: block;
        //     margin-left: 8px;
    	// }
    }

    .menu-shortcut {
        color: #a0a0a0;
    }

    // hasIcon用于有快捷键提示又有二级菜单小箭头icon的情况
    .menu-shortcut.hasIcon {
        margin-right: 10px;
        margin-left: auto;
    }

    .item-checked {
        line-height: 0;
        position: absolute;
    	display: block;
    	left: 14px;
    	top: 8px;
    	width: 14px;
    	height: 14px;
        /deep/.ivu-checkbox-inner {
            background-color var(--bg-color-menu-item-checkbox)
        }
    }
    .checked-menu-item::before {
    	line-height: 0;
    	content: url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNCcgaGVpZ2h0PScxNCcgdmlld0JveD0nMCAwIDE0IDE0JyBmaWxsPSdub25lJz48cmVjdCB4PScwLjUnIHk9JzAuNScgd2lkdGg9JzEzJyBoZWlnaHQ9JzEzJyByeD0nMi41JyBmaWxsPScjMDE3RkZGJyBzdHJva2U9JyMwMTdGRkYnLz48cGF0aCBkPSdNNCA3LjVMNi4xIDEwTDEwLjUgNC41JyBzdHJva2U9J3doaXRlJyBzdHJva2Utd2lkdGg9JzEuNScgc3Ryb2tlLWxpbmVjYXA9J3JvdW5kJyBzdHJva2UtbGluZWpvaW49J3JvdW5kJy8+PC9zdmc+");
    	position: absolute;
    	display: block;
    	left: 14px;
    	top: 8px;
    	width: 16px;
    	height: 16px;
    }
    .unchecked-menu-item::before {
        line-height: 0;
        content: url("data:image/svg+xml;charset=utf-8;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNCcgaGVpZ2h0PScxNCcgdmlld0JveD0nMCAwIDE0IDE0JyBmaWxsPSdub25lJz48cmVjdCB4PScwLjUnIHk9JzAuNScgd2lkdGg9JzEzJyBoZWlnaHQ9JzEzJyByeD0nMi41JyBmaWxsPSd3aGl0ZScgc3Ryb2tlPScjRTBFMEUwJy8+PC9zdmc+");
        position: absolute;
        display: block;
        left: 14px;
        top: 8px;
        width: 16px;
        height: 16px;
    }
    .menu-item {
    	display: flex;
        justify-content: space-between;
        align-items: center;
    	text-align: left;
    	line-height: 30px;
    	cursor: pointer;
    	white-space: nowrap;
    	height: 30px;
    	position: relative;
    	padding: 0 10px;
    	text-overflow: ellipsis;
        font-size 14px
        &.active,
    	&:hover:not(.disabled-menu-item) {
            background-color: var(--bg-color-menu-item-active)
            .item-checked {
                /deep/.ivu-checkbox-inner {
                    border-color: var(--border-color-ivu-checkbox-inner-hover-1);
                }
            }
            .item-box {
                .vip-icon {
                    display: inline-block;
                }
            }
        }
        &.item-title:not(.item-title-special){
            .item-box .menu-text {
                color: var(--color-black-50);
            }
        }
        &.item-title:not(.item-title-special) {
            opacity: 1 !important;
            cursor: auto !important;
            &:hover {
                background-color:var(--bg-color-menu-item-title-special);
            }

        }
        /deep/.item-box{
            display: flex;
            align-items: center;
            &.expand-padding {
                padding-left: 32px;
            }
            .item-logo, .item-icon{
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }
            .item-icon {
                &.gantt-ai-total,&.gantt-ai-share,
                /** */
                &.ai-text-expend,&.ai-node-expend,&.ai-text-retouch,&.ai-text-summary,&.ai-text-list,
                &.ai-text-elongate,&.ai-text-shorten,&.ai-text-tone,&.ai-text-translate,&.ai-more,&.ai-mindmap-arrange,
                &.ai-flowchart-analyse,&.ai-flowchart-improve,&.ai-flowchart-desc {
                    color: var(--svg-color-gray-42);
                    fill: var(--svg-color-gray-75);
                }
                &.gantt-ai-risk,&.gantt-ai-progress,&.gantt-add-above,&.gantt-add-below,
                &.gantt-subtask,&.gantt-delete,.gantt-right-menu-global-settings,&.gantt-right-menu-left-move-column,
                &.gantt-right-menu-right-move-column,&.gantt-right-menu-global-settings,&.ai-org-analysis,&.ai-org-diagnosis,
                &.ai-img-replace {
                    color: var(--svg-color-gray-42);
                }
                &.ai-img-replace {
                    fill: var(--svg-color-gray-75);
                    stroke: var(--svg-color-gray-42);
                }
                &.ai-org-analysis,&.ai-org-diagnosis,&.ai-menu-more,&.ai-flowchart-analyse,
                &.ai-flowchart-improve,&.ai-chart-compare,&.ai-chart-error,&.ai-chart-trend,&.ai-more {
                    stroke:var(--svg-color-gray-75);
                }
                &.gantt-right-menu-delete-column,&.gantt-right-menu-hidden-column,&.gantt-right-menu-insert-column {
                    color: var(--svg-color-gray-75)
                    stroke: var(--svg-color-gray-42);
                    fill: var(--svg-color-gray-d0);
                }
            }
            .big-item-log{
                padding 4px
            }
            .vip-icon{
                width: 12px;
                height: 12px;
                margin-left: 8px;
                display: none;

            }
        }

    }
    .export-menu-item{
        height: 32px;
        padding: 0 5px 0 10px
    }


    .menu-limitW {
    	display: block !important;
    	max-width: 300px;
    }

    // 功能搜索激活态
    .activeFunc {
        background-color: var(--themeActived);
    }
</style>

<template>
    <div :class="menuList.container">
        <slot v-for="(item, index) in menuList.list" :name="item.slot">
            <div
                :key="item.key || index"
                v-show="item.hasOwnProperty('show') ? item.show : true"
                :id="item.id"
                :class="[
                    item.divide ? 'menu-divide' : 'menu-item',
                    {
                        active: item.active,
                        'disabled-menu-item': item.disabled,
                        'expand-menu-item': item.expand,
                        'item-title': item.isTitle,
                        'item-title-special': item.index === 0,
                    },
                    item.extraClass,
                    sidebarClassName,
                ]"
                @click="handleClicks(item.key || index, item.disabled, $event)"
                @mouseenter="handleMouseenter(item.key || index, $event)"
                @mouseleave="handleMouseleave(item.key || index, $event)"
            >
                <template v-if="item.checked !== undefined">
                    <span class="item-checked">
                        <Checkbox :value="!!item.checked" />
                    </span>
                </template>
                <hr v-if="item.divide" />
                <template v-else>
                    <template v-if="showTippy">
                        <div
                            class="item-box"
                            :class="{ 'expand-padding': (menuListHasImg || hasChecked) && !item.img }"
                            v-tippy="{
                                content: item.hideTippy ? '' : item.tooltip || item.label,
                                placement: 'right',
                                flip: false,
                            }"
                        >
                            <template v-if="item.img && item.img.includes('/img/')">
                                <img class="item-logo" v-if="item.img" :src="item.img" alt="" :class="item.bigLogo ? 'big-item-log' : ''" />
                            </template>
                            <template v-else-if="item.img">
                                <iconSymbol class="item-icon" :class="item.img" :name="item.img" />
                            </template>
                            <span class="menu-text">
                                {{ item.label }}
                                <img :src="item.textIcon" alt="" class="text-icon" v-if="item.textIcon" />
                            </span>
                            <VipIcon v-if="item.showVip" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="item-box" :class="{ 'expand-padding': (menuListHasImg || hasChecked) && !item.img }">
                            <template v-if="item.img && item.img.includes('/img/')">
                                <img class="item-logo" v-if="item.img" :src="item.img" alt="" :class="item.bigLogo ? 'big-item-log' : ''" />
                            </template>
                            <template v-else-if="item.img">
                                <iconSymbol class="item-icon" :class="item.img" :name="item.img" />
                            </template>
                            <span class="menu-text">
                                {{ item.label }}
                                <img :src="item.textIcon" alt="" class="text-icon" v-if="item.textIcon" />
                            </span>
                            <VipIcon v-if="item.showVip" />
                        </div>
                    </template>
                    <img class="menu-tag" v-if="item.tag" :src="item.tag" alt="" />
                    <span v-if="item.shortcut || item.hasIcon" :class="{ 'menu-shortcut': item.shortcut, hasIcon: item.hasIcon }">
                        {{ item.shortcut }}
                    </span>
                </template>
                <span v-if="item.expand" class="menu-item-icon">
                    <iconSymbol name="menu-list-expand-arrow" />
                </span>
            </div>
        </slot>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component
    export default class RightMenu extends Vue {
        @Prop({ default: () => [] }) readonly menuList: any;
        @Prop({ default: "" }) readonly sidebarClassName: any;
        @Prop({ default: true }) readonly showTippy: boolean;
        debounceInput = undefined;
        // 在父组件使用原生写法代替事件修饰符，例如 event.stopPropagation()
        // 第三个参数是立即执行flag
        debounce(func, delay = 1000, immediate = false) {
            const ts = this;
            return function (...args) {
                if (immediate && !ts.showContextExpandTimer) {
                    func.apply(ts, args);
                }
                ts.showContextExpandTimer && clearTimeout(ts.showContextExpandTimer);
                ts.showContextExpandTimer = setTimeout(() => {
                    func.apply(ts, args);
                }, delay);
            };
        }

        get showContextExpandTimer() {
            return this.$store.state.ui.showContextExpandTimer;
        }
        set showContextExpandTimer(newV) {
            this.$store.commit("setStatus", {
                type: "showContextExpandTimer",
                data: newV,
            });
        }

        get menuListHasImg() {
            return this.menuList.list.some((item) => item.img != undefined);
        }

        // 判断下拉框是否有多选
        get hasChecked() {
            return this.menuList.list.some((item) => item.hasOwnProperty("checked"));
        }

        get dropType() {
            return this.$store.state.ui.dropType;
        }

        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }

        handleClicks(flag, disable, e) {
            if (disable) return;
            this.$emit("handleClicks", flag, e);
        }

        handle(Fun, flag, e) {
            this.$emit(Fun, flag, e);
        }

        handleMouseenter(flag, e) {
            // 清空搜索结果高亮
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: "",
            });
            // 顶部工具栏的二级菜单不需要转换，因为他们展开的机制不一样，此处转换的只是对不一致type值进行转换
            switch (flag) {
                // 层级
                case "bringFront":
                case "sendBack":
                case "bringForward":
                case "sendBackWard":
                    flag = "layer";
                    break;
                // 对齐
                case "left":
                case "center":
                case "right":
                case "top":
                case "middle":
                case "bottom":
                case "alignObject":
                    flag = "align";
                    break;
                // 分布
                case "horizontal":
                case "vertical":
                case "distributeObject":
                    flag = "distribute";
                    break;
                // 等大小
                case "width":
                case "height":
                case "angle":
                case "width&height":
                    flag = "sameSize";
                    break;
                // 按类型选中
                case "connector":
                case "shape":
                case "img":
                case "guideLine":
                    flag = "selectByType";
                    break;
                // 网格
                case "showGrid":
                case "snapGrid":
                case "gridSetting":
                    flag = "grid";
                    break;
                // 参考线
                case "showGuides":
                case "snapGuides":
                    flag = "guide";
                    break;
                // 连接线交点样式
                case "showLine":
                case "crossPoint0":
                case "crossPoint1":
                case "crossPoint2":
                case "crossPoint3":
                case "crossPoint4":
                case "crossPoint5":
                    flag = "lineJump";
                    break;
                // 页面边距
                case "showMargins":
                case "marginSetting":
                    flag = "margins";
                    break;
                // 组合
                case "group":
                case "unGroup":
                    flag = "Group";
                    break;
                // 插入
                case "insNote":
                case "insCom":
                case "insHyper":
                case "insAttach":
                case "insert":
                    flag = "Insert";
                    break;
                // 显示泳道图主标题
                case "noShow":
                case "showTop":
                case "showLeft":
                case "showSwimMainTitle":
                    flag = "swimTitle";
                    break;
                // 直接二级菜单符号库的
                case "addSymbolToLibs":
                    flag = "addSymbolFromPageToLibs";
                    break;
                // 添加到我的符号库 (左侧符号库)
                case "addToCollect":
                    flag = "addSymbolToLibs";
                    break;
                // 粘贴
                case "pasteText":
                    flag = "rememberFontStyle";
                    break;
                // 替换形状
                case "replaceShape":
                    flag = "libraryExpand";
                    break;
                // 移动到图层
                case "moveLayer":
                    flag = "mvLayer";
                    break;
                // 发送到新页面
                case "sendToNewPage":
                    flag = "mvPage";
                    break;
                // 锁定
                case "lock":
                    flag = "lockExpand";
                    break;
                // 另存为
                case "saveAs":
                    flag = "SaveAs";
                    break;
                // 文档加密
                case "encryptfile":
                    flag = "Crypt";
                    break;
                // 导入
                case "importMenu":
                    flag = "Import";
                    break;
                // 导出
                case "downloadAs":
                    flag = "Download";
                    break;
                // 按图层选中
                case "selByLayer":
                    flag = "selectLayer";
                    break;
                // 同类型形状
                case "selByShapes":
                    flag = "selectShapes";
                    break;
                // 同类型连接线
                case "selByLines":
                    flag = "selectLines";
                    break;
                // 从选择中排除
                case "excludeBySel":
                    flag = "excludeSel";
                    break;
                default:
                    break;
            }
            // 鼠标移入 push进enter队列，延迟一段时间内没有mouseenter操作，执行最后一次mouseenter的操作
            // this.$emit("handleMouseenter", flag, e);
            this.debounceInput("handleMouseenter", flag, e);
        }

        handleMouseleave(flag, e) {
            this.$emit("handleMouseleave", flag, e);
        }

        mounted() {
            this.debounceInput = this.debounce(this.handle, 300, false);
        }
    }
</script>
